import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {Q9HtmlEncoderPipe} from '@q9elements/ui-kit/common';
import {
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  TextareaFieldComponent,
  TextFieldComponent
} from '@q9elements/ui-kit/components';
import {Q9Validators} from '@q9elements/ui-kit/validators';
import {LegendItemDialogPayload} from './models/legend-item-dialog-payload.interface';

@Component({
  selector: 'app-legend-item-text-dialog',
  templateUrl: './legend-item-text-dialog.component.html',
  styleUrls: ['./legend-item-text-dialog.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    DialogCloseButtonComponent,
    TextFieldComponent,
    TextareaFieldComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    Q9HtmlEncoderPipe
  ]
})
export class LegendItemTextDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  public isEdit = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: LegendItemDialogPayload,
    private dialogRef: MatDialogRef<LegendItemTextDialogComponent>,
    private readonly encodeHtml: Q9HtmlEncoderPipe
  ) {}

  ngOnInit() {
    this.isEdit = !!this.data?.isEdit;

    const text = this.isEdit ? this.data.text : '';
    const description = this.isEdit ? this.data.description : '';

    this.form = new UntypedFormGroup({
      text: new UntypedFormControl(this.encodeHtml.transform(text, true), [
        Q9Validators.required(),
        Q9Validators.minLength(2),
        Q9Validators.maxLength(60)
      ]),
      description: new UntypedFormControl(this.encodeHtml.transform(description, true), [
        Q9Validators.maxLength(400)
      ])
    });
  }

  public onSubmit() {
    const payload = this.form.value;

    payload.text = this.encodeHtml.transform(payload.text, false);
    payload.description = this.encodeHtml.transform(payload.description, false);

    if (this.form.valid) {
      this.dialogRef.close(payload);
    }
  }
}
